function resizeAndCompressImage(imageFile, maxWidth, maxHeight, quality, callback) {
    const reader = new FileReader();

    reader.onload = function(event) {
        const img = new Image();
        img.src = event.target.result;

        img.onload = function() {
            let width = img.width;
            let height = img.height;

            // Вычисляем новый размер с учетом пропорций
            if (width > maxWidth || height > maxHeight) {
                const aspectRatio = width / height;
                if (width > height) {
                    width = maxWidth;
                    height = Math.round(maxWidth / aspectRatio);
                } else {
                    height = maxHeight;
                    width = Math.round(maxHeight * aspectRatio);
                }
            }

            // Создаем canvas для изменения размера
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            // Конвертируем в сжатый формат
            canvas.toBlob(
                (blob) => callback(blob),
                'image/jpeg', 
                quality
            );
        };
    };

    reader.readAsDataURL(imageFile);
}

async function resizeImageToSpecificWidth(max, file, cb) {
    if (max == 'full') {
        if (file) {
            await cb(file)
        }
    } else {
        if (file) {
            resizeAndCompressImage(file, 600, 600, 0.8, async (compressedBlob) => {
                let newFile = new File([compressedBlob], file.name)
                await cb(newFile)
            })
        }
    }
}

export default resizeImageToSpecificWidth